// Copyright (c) 2016 Deere & Company

import claims from './claims';
import dbs from './dbs';
import dealer from './dealer';
import general from './general';
import language from './language';
import partReturn from './part-returns';
import reimbursementSummary from './reimbursement-summary';
import settings from './settings';
import theme from './theme';

const settingsRoute = {
    ...settings,
    childRoutes: [
        claims,
        dbs,
        dealer,
        general,
        language,
        partReturn,
        reimbursementSummary,
        theme
    ],
    indexRoute: {
        onEnter: (nextState, replace) => replace('/settings/general')
    }
};

export default settingsRoute;



// WEBPACK FOOTER //
// ./src/routes/settings/index.js